import {
    Button,
    CssBaseline,
    makeStyles,
    Typography,
    List,
    ListItem,
    Box,
    Checkbox,
} from '@material-ui/core';
import { COLORS } from '../Theme';

import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import {
    admin as v_admin,
    basic,
    Values,
    SNACKBAR_TIME,
} from '../../request/values';
import ToastStr from '../../request/toastStr';
import { useCookies } from 'react-cookie';

//const SERVER = basic.server;

const useStyles = makeStyles((theme) => ({
    nanumSquare_regular: {
        fontFamily: 'NanumR',
    },
    background: {
        width: '100vw',
        height: '100vh',
        background: `url("/images/background.png")`,
    },
    content: {
        width: '100%',
        height: '100%',
        display: 'grid',
        //gridTemplateColumns: '230px 1fr',
    },
    mainPage: {
        display: 'grid',
        gridTemplateRows: '1.5fr 5fr',
    },
    title: {
        margin: '5vh 0px 0px 35px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        display: 'flex',
        gap: '10vw',
    },
    logo: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'stretch',
        //border: 'solid white',
        margin: '5vh 0px',
        borderWidth: '0px 0px 1px 0px',
        //cursor: 'pointer',
        '& img': {
            width: '30px',
            maxHeight: '50%',
            height: '30px',
            margin: '12px 5px 0px 9%',
        },
        '& #name': {
            display: 'inline-block',
            margin: '10px 0px 0px 0px',
            width: 'calc(91% - 35px)',
            fontFamily: 'NanumR',
            fontSize: '1.5rem',
            fontWeight: 'bolder',
        },
        '& #welcome': {
            display: 'block',
            margin: '5px 0px 0px 9%',
            fontFamily: 'NanumR',
            fontSize: '1.2rem',
        },
    },
    menu: {
        display: 'grid',
        border: 'none',
        borderWidth: '0px 0px 1px 0px',
        fontFamily: 'NanumR',
        fontSize: '1.5rem',
        fontWeight: 'bold',
        '&::after': {
            content: '""',
            position: 'absolute',
            width: '0',
            height: '0',
            left: '50%',
            bottom: '0',
            borderBottom: '3px solid black',
            transition: 'width 0.3s ease, left 0.3s ease',
            WebkitTransition: 'width 0.3s ease, left 0.3s ease',
        },
        '&:hover::after': {
            width: '100%',
            left: '0',
        },
        '&:hover': {
            backgroundColor: 'transparent', // hover 배경색 제거
        },
    },
    navigator: {
        display: 'grid',
        gridTemplateColumns: '1fr 2fr',
        marginTop: '1%',
        //fontSize: '5vw',
        //backgroundColor: `${COLORS.WHITE}`,
    },
    subTitle: {
        minWidth: '10vw',
        display: 'flex',
        flexDirection: 'column',
    },
    menuOpen: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        marginTop: '10px',
        gap: '10px',
        '& a': {
            margin: '5px',
            fontSize: '1rem',
            width: 'fit-content',
            height: '100%',
            cursor: 'pointer',
            textAlign: 'center',
            position: 'relative',
            '&::after': {
                content: '""',
                position: 'absolute',
                display: 'inline-block',
                width: '0',
                height: '0',
                left: '50%',
                bottom: '-5px',
                borderBottom: '2px solid black',
                transition: 'width 0.3s ease, left 0.3s ease',
                WebkitTransition: 'width 0.3s ease, left 0.3s ease',
            },
            '&:hover::after': {
                width: '100%',
                left: '0',
            },
        },
    },
    menuClose: {
        display: 'none',
    },
    classList: {
        '& #classOpen': {
            float: 'right',
            margin: '5px 3%',
            padding: '5px 25px',
            color: `${COLORS.WHITE}`,
            borderRadius: '5px',
            backgroundColor: `${COLORS.WATER_BLUE}`,
            '&:hover': {
                color: `${COLORS.WATER_BLUE}`,
                backgroundColor: 'inherit',
            },
        },
    },
    table: {
        display: 'grid',
        gridTemplateRows: '50px 1fr',
        width: '94%',
        height: '60vh',
        margin: '1% 3%',
        //border: 'none',
        //borderRadius: '10px 10px 0 10px',
        '& #title': {
            display: 'grid',
            gridTemplateColumns: '3fr 5fr 3fr 3fr 2fr 1fr 17px',
            border: 'solid',
            borderWidth: '0 0 2px 0',
            //background: 'none',
            '& span': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '& p': {
                    fontSize: '1.15rem',
                    fontWeight: 'bolder',
                },
            },
        },
        '& #classinfo': {
            overflow: 'scroll',
            overflowX: 'hidden',
            borderRadius: '0 0 0 10px',
        },
        '& ul': {
            padding: '0',
        },
        '& li': {
            border: 'solid gray',
            borderWidth: '0 0 1px 0',
        },
    },
    classInfo: {
        display: 'grid',
        gridTemplateColumns: '3fr 5fr 3fr 3fr 2fr 1fr',
        padding: '25px 0',
        //backgroundColor: `${COLORS.LIGHT_GREY}`,
        backgroundColor: `${COLORS.WHITE}`,
    },
    buttonLabel: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'none',
        fontSize: '1rem',
        fontFamily: 'NanumB',
        //fontWeight: 'bold',
        lineHeight: '21px',
        bolderWidth: '1px',
    },
    blank: {
        display: 'flex',
        height: '40px',
    },
    operApprove: {
        float: 'right',
        margin: '5px 3%',
        padding: '5px 25px',
        color: `${COLORS.WHITE}`,
        borderRadius: '5px',
        backgroundColor: `${COLORS.WATER_BLUE}`,
        '&:hover': {
            color: `${COLORS.WATER_BLUE}`,
            backgroundColor: 'inherit',
        },
    },
    operDelete: {
        float: 'right',
        margin: '5px 3%',
        padding: '5px 25px',
        color: `${COLORS.WHITE}`,
        borderRadius: '5px',
        backgroundColor: `#f50057`,
        '&:hover': {
            color: `#f50057`,
            backgroundColor: 'inherit',
        },
    },
}));

type iOperList = {
    operator_email: string;
    operator_name: string;
    operator_phone: string;
    join_date: string;
    approve: boolean;
};

const SERVER = basic.server;

const SubAdminOperList: React.FC<any> = (props) => {
    const classes = useStyles();
    let history = useHistory();

    const { member } = props;

    const [ClassList, setClassList] = useState<iOperList[]>([]);
    const [menu, setMenu] = useState<boolean>(false);
    const [checkedCodes, setCheckedCodes] = useState<String[]>([]);
    const { enqueueSnackbar } = useSnackbar();
    const [page, setPage] = useState(1);
    const loader = useRef(null);
    const [operMenu, setOperMenu] = useState<boolean>(false);

    const moveClassList = () => {
        history.push('/subAdminClassList');
    };
    const moveClassManage = () => {
        history.push('/subAdminClassManage');
    };
    const moveOperList = () => {
        history.push('/subAdminOperList');
    };

    const postOperApprove = () => {
        if (checkedCodes === undefined || checkedCodes.length === 0)
            enqueueSnackbar(ToastStr.OPER_CHECKED_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
            });
        else {
            axios({
                method: 'POST',
                data: {
                    oper_emails: checkedCodes,
                },
                withCredentials: true,
                url: SERVER + v_admin.admin + v_admin.oper_approval,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    console.log(data.code);
                    if (data.code == Values.SUCCESS_CODE) {
                        enqueueSnackbar(ToastStr.OPER_APPROVE_SUCCESS_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                        });
                    } else {
                        if (data.code == Values.FAIL_CODE) {
                            enqueueSnackbar(ToastStr.OPER_APPROVE_FAIL_STR, {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        } else {
                            enqueueSnackbar(
                                ToastStr.REQUEST_GET_POST_FAIL_STR,
                                {
                                    variant: 'error',
                                    autoHideDuration: SNACKBAR_TIME,
                                }
                            );
                        }
                    }
                })
                .then(() => {
                    setPage(1);
                    getOperList(1);
                    setCheckedCodes([]);
                });
        }
    };

    const postOperDelete = () => {
        if (checkedCodes === undefined || checkedCodes.length === 0)
            enqueueSnackbar(ToastStr.OPER_CHECKED_STR, {
                variant: 'warning',
                autoHideDuration: SNACKBAR_TIME,
            });
        else {
            axios({
                method: 'POST',
                data: {
                    oper_emails: checkedCodes,
                },
                withCredentials: true,
                url: SERVER + v_admin.admin + v_admin.oper_delete,
            })
                .then((res) => {
                    return res.data;
                })
                .then((data: any) => {
                    console.log(data);
                    console.log(data.code);
                    if (data.code == Values.SUCCESS_CODE) {
                        enqueueSnackbar(ToastStr.OPER_DELETE_SUCCESS_STR, {
                            variant: 'success',
                            autoHideDuration: SNACKBAR_TIME,
                        });
                    } else {
                        if (data.code == Values.FAIL_CODE) {
                            enqueueSnackbar(ToastStr.OPER_DELETE_FAIL_STR, {
                                variant: 'warning',
                                autoHideDuration: SNACKBAR_TIME,
                            });
                        } else {
                            enqueueSnackbar(
                                ToastStr.REQUEST_GET_POST_FAIL_STR,
                                {
                                    variant: 'error',
                                    autoHideDuration: SNACKBAR_TIME,
                                }
                            );
                        }
                    }
                })
                .then(() => {
                    setPage(1);
                    getOperList(1);
                    setCheckedCodes([]);
                });
        }
    };

    const getOperList = (page: number) => {
        let url = new URL(SERVER + v_admin.admin + v_admin.oper_list);
        url.searchParams.append('page', String(page));
        url.searchParams.append('limit', '30');
        axios({
            method: 'GET',
            withCredentials: true,
            url: url.toString(),
            headers: {
                'Access-Control-Allow-Origin': basic.server_url,
                mode: 'cors',
                'Access-Control-Allow-Headers':
                    'Origin, X-Requested-With, Content-Type, Accept',
            },
        })
            .then((res) => {
                return res.data;
            })
            .then((data: any) => {
                console.log('data?', data);
                if (data.code == Values.SUCCESS_CODE) {
                    if (page === 1) setClassList(data.data);
                    else {
                        setClassList((prevClassList) => [
                            ...prevClassList,
                            ...data.data,
                        ]);
                    }
                }
            });
    };

    const handleCheckboxChange = (email: String, isChecked: boolean) => {
        setCheckedCodes((prev: any) => {
            if (isChecked) {
                return [...prev, email];
            } else {
                return prev.filter((code: String) => code !== email);
            }
        });
    };

    const handleObserver = useCallback((entries: any) => {
        const target = entries[0];
        if (target.isIntersecting) {
            setPage((prevState) => {
                if (prevState + 1 > 999) {
                    return prevState;
                }
                return prevState + 1;
            });
        }
    }, []);

    useEffect(() => {
        const setLoader = () => {
            const option = {
                root: null,
                rootMargin: '20px',
                threshold: 0,
            };
            // console.log('in infinite useEffect')
            const observer = new IntersectionObserver(handleObserver, option);
            if (loader.current) observer.observe(loader.current!);
        };
        setTimeout(() => setLoader(), 100);
    }, [handleObserver]);

    useEffect(() => {
        getOperList(page);
    }, [page]);

    return (
        <div className={classes.background}>
            <CssBaseline />
            <div className={classes.content}>
                <div className={classes.mainPage}>
                    <div className={classes.navigator}>
                        <div className={classes.logo}>
                            <img src="/images/p.webp"></img>
                            <Typography id="name">플레이스타트업</Typography>
                            <Typography id="welcome">
                                {member.name}님, 환영합니다!
                            </Typography>
                        </div>
                        <div className={classes.title}>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setMenu(true);
                                }}
                                onMouseOut={() => {
                                    setMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveClassList()}
                                >
                                    교육
                                </Button>
                                <div
                                    className={
                                        menu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveClassList()}>
                                        교육 목록
                                    </a>
                                    <a onClick={(e) => moveClassManage()}>
                                        교육 관리 목록
                                    </a>
                                </div>
                            </div>
                            <div
                                className={classes.subTitle}
                                onMouseOver={() => {
                                    setOperMenu(true);
                                }}
                                onMouseOut={() => {
                                    setOperMenu(false);
                                }}
                            >
                                <Button
                                    className={classes.menu}
                                    onClick={() => moveOperList()}
                                >
                                    강사
                                </Button>
                                <div
                                    className={
                                        operMenu
                                            ? classes.menuOpen
                                            : classes.menuClose
                                    }
                                >
                                    <a onClick={(e) => moveOperList()}>
                                        강사 관리
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={classes.classList}>
                        <div className={classes.table}>
                            <div id="title">
                                <span>
                                    <Typography>강사 이름</Typography>
                                </span>
                                <span>
                                    <Typography>등록 메일</Typography>
                                </span>
                                <span>
                                    <Typography>전화 번호</Typography>
                                </span>
                                <span>
                                    <Typography>등록 일자</Typography>
                                </span>
                                <span>
                                    <Typography>승인 여부</Typography>
                                </span>
                            </div>
                            <List id="classinfo">
                                {ClassList != null &&
                                    ClassList.map(
                                        (item: any, index: number) => {
                                            return (
                                                <AppListItem
                                                    index={index}
                                                    name={item.operator_name}
                                                    email={item.operator_email}
                                                    phone={item.operator_phone}
                                                    date={item.join_date.slice(
                                                        2,
                                                        10
                                                    )}
                                                    approve={item.approve}
                                                    checked={checkedCodes.includes(
                                                        item.operator_email
                                                    )}
                                                    onCheckboxChange={
                                                        handleCheckboxChange
                                                    }
                                                />
                                            );
                                        }
                                    )}
                                <div
                                    className={classes.blank}
                                    ref={loader}
                                ></div>
                            </List>
                        </div>
                        <Button
                            className={classes.operDelete}
                            onClick={postOperDelete}
                        >
                            <Typography>관리자 삭제</Typography>
                        </Button>
                        <Button
                            className={classes.operApprove}
                            onClick={postOperApprove}
                        >
                            <Typography>관리자 승인</Typography>
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

const AppListItem: React.FC<any> = (props) => {
    const classes = useStyles();
    const { index, name, email, phone, date, approve, checked } = props;
    const [isChecked, setIsChecked] = useState(checked);

    useEffect(() => {
        setIsChecked(checked);
    }, [checked]);

    const handleCheckboxChange = (event: any) => {
        setIsChecked(event.target.checked);
        props.onCheckboxChange(email, event.target.checked);
    };

    return (
        <ListItem id={index} className={classes.classInfo}>
            <Box className={classes.buttonLabel}>{name}</Box>
            <Box className={classes.buttonLabel}>{email}</Box>
            <Box className={classes.buttonLabel}>{phone}</Box>
            <Box className={classes.buttonLabel}>{date}</Box>
            <Box
                className={classes.buttonLabel}
                style={{ color: approve ? '#1291d9' : '#f50057' }}
            >
                {approve ? '승인 완료' : '대기 중'}
            </Box>
            <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                inputProps={{ 'aria-label': 'primary checkbox' }}
            />
        </ListItem>
    );
};

export default SubAdminOperList;
